(function templateDefinition() {
    'use strict';
    angular.module('Entities')
        .service('templateService', [
            'restUrlBuilder', function templateService(restUrlBuilder) {

                var templateBuilder = restUrlBuilder('cpp');
                this.getTemplate = function getTemplate() {
                    return templateBuilder.one('Templates', 'LD').get();
                };
            }
        ]);
})();